import Raven from 'raven-js';
export const reportError = ({
  error,
  tags = {},
  ignoreMeta = {
    errorStatus: []
  },
  extraData = {}
}) => {
  if (error && typeof error === 'object' && 'status' in error && ignoreMeta.errorStatus.some(status => status === error.status)) {
    return null;
  }
  const errorToReport = error instanceof Error ? error : new Error(error.message);
  Raven.captureException(errorToReport, {
    tags,
    extra: Object.assign({}, extraData, {
      error
    })
  });
  const lastEventId = Raven.lastEventId();
  console.error(`(Event Id: ${lastEventId})\nError reported with '${error.message}'`);
  return lastEventId;
};